module.exports = __webpack_public_path__ + "assets/img/box-bg1.f8ae9822.png";